// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxxlargeOnWide-superElipse-82c8f443","strokeWidth":"super-ellipse-skins-xxxlargeOnWide-strokeWidth-817b9c2e"};